module.exports = __webpack_public_path__ + "static/pelton-2a16839a136486df4b7e3c25d7a7e473.png";